import { Component } from '@angular/core';
import { UnsupportedCase } from '../../../../classes/UnsupportedUseCases';

import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'unsupported-button',
  templateUrl: './unsupported-button.component.html',
})
export class UnsupportedButtonComponent extends BaseFormComponent {
  showUnsupportedGenericModal() {
    this.unsupportedUseCasesService.activateUnsupportedUseCasesModal(UnsupportedCase.genericUnsupportedMessage);
  }

  updateFromModel(): void {}
}
